var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rmr-soft-badge',{attrs:{"label":_vm.config.label,"color":_vm.config.color,"background":_vm.config.background,"title":("Provenance : " + (_vm.config.label)),"size":"xs"}})}
var staticRenderFns = []

export { render, staticRenderFns }